import { render, staticRenderFns } from "./CallBar.vue?vue&type=template&id=127006d6&"
import script from "./CallBar.vue?vue&type=script&lang=js&"
export * from "./CallBar.vue?vue&type=script&lang=js&"
import style0 from "./CallBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports